<template>
  <div
    class="tabs-container ng-scope"
    style="padding-bottom: 50px; margin-top: 18px"
  >
    <el-form
      :model="category"
      ref="category"
      label-width="0px"
      class="demo-dynamic form-horizontal detailPage"
    >
      <el-tabs type="border-card">
        <el-tab-pane label="English">
          <div class="form-group">
            <label class="col-sm-2 control-label">
              Sub-Category Name
              <span style="color: red">*</span>
            </label>
            <div class="col-sm-10">
              <el-form-item
                prop="categoryNameEn"
                :rules="[
                  {
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input
                  v-model="category.categoryNameEn"
                  :name="'categoryNameEn'"
                />
              </el-form-item>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="Simplified Chinese">
          <div class="form-group">
            <label class="col-sm-2 control-label">
              Sub-Category Name
              <span style="color: red">*</span>
            </label>
            <div class="col-sm-10">
              <el-form-item
                prop="categoryNameSc"
                :rules="[
                  {
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input
                  v-model="category.categoryNameSc"
                  :name="'categoryNameSc'"
                />
              </el-form-item>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="Traditional Chinese">
          <div class="form-group">
            <label class="col-sm-2 control-label">
              Sub-Category Name
              <span style="color: red">*</span>
            </label>
            <div class="col-sm-10">
              <el-form-item
                prop="categoryNameTc"
                :rules="[
                  {
                    required: true,
                    message: $t('message.required'),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input
                  v-model="category.categoryNameTc"
                  :name="'categoryNameTc'"
                />
              </el-form-item>
            </div>
          </div>
        </el-tab-pane>
        <div class="form-group">
          <label class="col-sm-2 control-label">
            Category Type <span style="color: red">*</span></label
          >
          <div class="col-sm-10">
            <el-form-item
              prop="categoryType"
              :rules="{
                required: true,
                message: $t('message.required'),
                trigger: 'blur',
              }"
            >
              <el-select v-model="category.categoryType">
                <el-option
                  v-for="item in [
                    { val: 1, text: 'Picture' },
                    { val: 2, text: 'Video' },
                  ]"
                  :key="item.val"
                  :label="item.text"
                  :value="item.val"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
        <div class="form-group">
          <div class="col-sm-12">
            <div class="pull-right">
              <el-button
                type="primary"
                v-if="
                  (checkPermission('SchoolResourcesCategory_LIST_EDI') &&
                    $route.query.id) ||
                  (checkPermission('SchoolResourcesCategory_LIST_ADD') &&
                    !$route.query.id)
                "
                @click="checkEvent()"
              >
                {{ $t("message.Save") }}
              </el-button>
              <el-button @click="handleBack($router.go(-1))">{{
                $t("message.Cancel")
              }}</el-button>
            </div>
          </div>
        </div>
      </el-tabs>
    </el-form>
  </div>
</template>
<script>
import config from "../config";
import sha256 from "sha256";

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      category: {
        categoryNameEn: "",
        categoryNameSc: "",
        categoryNameTc: "",
        categoryType: "",
      },
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    checkEvent() {
      this.$refs["category"].validate((valid) => {
        if (valid) {
          this.submit();
        } else {
          return false;
        }
      });
    },

    async init() {
      let id = this.$route.query.id;
      var that = this;
      if (id) {
        let obj = this.getAuthObj();
        obj.id = id;
        obj.apiUrl = this.apiConfig.schoolResourcesCategoryDetail;
        let data = await this.$store.dispatch("apiEvent", obj);
        if (data == "000104") {
          this.timeoutEvent();
          return;
        }
        if (data.data.result.startTime) {
          this.period = [data.data.result.startTime, data.data.result.endTime];
        }
        if (!data) return;
        for (var key in this.category) {
          this.category[key] = data.data.result[key];
        }
        //this.$set(this, "category", data.data.result);
        this.showFileUrl = data.data.result.showFileUrl;

        setTimeout(function () {
          that.$store.state.edit = false;
        }, 500);
      } else {
        setTimeout(function () {
          that.$store.state.edit = false;
        }, 500);
      }
    },
    async submit() {
      let obj = this.getAuthObj();

      for (var key in this.category) {
        obj[key] = this.category[key];
      }
      var data;
      if (this.$route.query.id) {
        obj.id = this.$route.query.id;
        obj.apiUrl = this.apiConfig.schoolResourcesCategoryUpdate;
        data = await this.$store.dispatch("apiEvent", obj);
      } else {
        obj.apiUrl = this.apiConfig.schoolResourcesCategoryCreate;
        data = await this.$store.dispatch("apiEvent", obj);
      }
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      if (data.data.status_code === "0") {
        this.$router.go(-1);
      }
    },
  },
};
</script>
